import {objectToQueryString} from './utils';
import {getClientState, urls} from '../config';

export function getInnerOpenAppUrl(appSlug) {
  const mode = getClientState().mode;
  return `${mode.baseUrl}/app-modal/${appSlug}/?${objectToQueryString(mode.query)}`;
}

export function getInnerAppPermissionsUrl(app) {
  const mode = getClientState().mode;
  return `${mode.baseUrl}/permissions-modal/${app.slug}/?${objectToQueryString(mode.query)}`;
}

export function getInnerProvisionSuccessUrl(app) {
  const mode = getClientState().mode;
  return `${mode.baseUrl}/provision-modal/${app.slug}/?${objectToQueryString(mode.query)}`;
}

export function getBusinessAppPageUrl(app) {
  const query = getClientState().mode.query;
  return `${urls.myAccount}/sites/${query.metaSiteId}/app/${app.appDefinitionId}/?referralInfo=ed_market`;
}

export function getDashboardPendingAppsUrl() {
  const query = getClientState().mode.query;
  return `${urls.myAccount}/sites/${query.metaSiteId}/apps/pending-apps?referralInfo=ed_market`;
}



// WEBPACK FOOTER //
// ./services/url-generator.js